export default __webpack_public_path__ + "static/media/triple.33b3dbf9.svg";